import React, { useState } from 'react';
import { cloneDeep } from 'lodash';

import ModalWrapper from '../../base/modals/modal-wrapper';
import Icon from '../../ui/icon';

import { titleCase } from '../../base/common/utils';
import AccountService from './account-service';

const CategoryModal = ({ setShowModal, value }) => {
  const [categories, setCategories] = useState(cloneDeep(value));
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(null);
  const [selectedCategoryValue, setSelectedCategoryValue] = useState(null);

  function handleClickPencil(index) {
    setSelectedCategoryValue(titleCase(categories[index]));
    setSelectedCategoryIndex(index);
  }

  function handleClickX(index) {
    const newCategories = cloneDeep(categories);
    newCategories.splice(index, 1);
    setCategories(newCategories);
  }

  function handleSave() {
    const newCategories = cloneDeep(categories);
    if (selectedCategoryIndex < newCategories.length) {
      newCategories[selectedCategoryIndex] = selectedCategoryValue;
    } else {
      newCategories.push(selectedCategoryValue);
    }
    setCategories(newCategories);
    setSelectedCategoryIndex(null);
  }

  function handleClickAddCategory() {
    setSelectedCategoryValue('');
    setSelectedCategoryIndex(categories.length);
  }

  const categoryItems = categories.map((category, index) =>
    selectedCategoryIndex !== index ? (
      <div key={index} className="category">
        <div className="category-chip">{category}</div>
        <div className="icons">
          <div onClick={() => handleClickPencil(index)}>
            <Icon iconName="pencil" size={15} />
          </div>
          <div onClick={() => handleClickX(index)}>
            <Icon iconName="x" size={13} />
          </div>
        </div>
      </div>
    ) : (
      <div key={index} className="category">
        <div className="input-save">
          <input
            value={selectedCategoryValue}
            onChange={e => setSelectedCategoryValue(e.target.value)}
          />
          <button className="save" onClick={handleSave}>
            Save
          </button>
        </div>
        <button className="cancel" onClick={() => setSelectedCategoryIndex(null)}>
          Cancel
        </button>
      </div>
    ),
  );

  const addCategoryItem =
    categories.length !== selectedCategoryIndex ? (
      <button className="add-category" onClick={handleClickAddCategory}>
        <span>+</span> Add Category
      </button>
    ) : (
      <div className="category">
        <div className="input-save">
          <input
            value={selectedCategoryValue}
            onChange={e => setSelectedCategoryValue(e.target.value)}
            placeholder="Category Name"
          />
          <button className="save" onClick={handleSave}>
            Add
          </button>
        </div>
        <button className="cancel" onClick={() => setSelectedCategoryIndex(null)}>
          Cancel
        </button>
      </div>
    );

  return (
    <div className="category-modal">
      <ModalWrapper closeModal={() => setShowModal(null)}>
        <div className="content" onClick={e => e.stopPropagation()}>
          <div className="header">Manage Categories</div>
          <div className="description">
            The categories in this list will be used to categorize and tag Creators and Merchants.
          </div>
          <div className="categories">
            {addCategoryItem}
            {categoryItems}
          </div>
          <hr></hr>
          <div className="buttons">
            <button className="cancel" onClick={() => setShowModal(null)}>
              Cancel
            </button>
            <button className="save" onClick={() => AccountService.editCategories(categories)}>
              Save Changes
            </button>
          </div>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default CategoryModal;
